module.exports = __webpack_public_path__ + "img/Bart.d64921af.jpeg";